<template>
  <div class="background">
    <div class="cabeçalho-palestras-inscritas">
      <h2 class="titulo-palestras-inscritas">Palestras inscritas</h2>
    </div>
    <div class="palestras">
      <b-alert v-model="showError" show variant="light" dismissible>
        <b-icon-exclamation-triangle-fill
          variant="danger"
        ></b-icon-exclamation-triangle-fill>
        {{ textError }}
      </b-alert>
      <!-- <ButtonFill
        @click="onClickGerarCertificado"
        :showSpinner="showSpinner"
        class="btn"
        texto="Gerar Certificado"
      ></ButtonFill> -->
    </div>
    <SeletorData class="seletor" v-model="diaSelecionado"></SeletorData>
    <b-row class="palestras d-none d-lg-flex rowpalestras" align-h="center">
      <CardPalestraUsuario
        v-for="(inscricao, index) in inscricoes"
        v-bind:key="inscricao.id"
        :palestra="inscricao.palestra"
        @cancelarInscricao="onClickCancelarInscricao(index)"
        :isInscrito="true"
        @saibaMais="onClickSaibaMais()"
      ></CardPalestraUsuario>
    </b-row>
    <b-row class="palestras d-lg-none rowpalestras" align-h="center">
      <CardPalestraUsuarioMobile
        v-for="(inscricao, index) in inscricoes"
        v-bind:key="inscricao.id"
        :palestra="inscricao.palestra"
        @cancelarInscricao="onClickCancelarInscricao(index)"
        :isInscrito="true"
        @saibaMais="onClickSaibaMais()"
      ></CardPalestraUsuarioMobile>
    </b-row>
    <b-modal
      id="my-modal"
      title="Cancelar inscrição"
      ok-title="Sim"
      ok-variant="danger"
      cancel-title="Não"
      @ok="onCancelarInscricao()"
      >Tem certeza que quer cancelar a inscrição para a palestra?</b-modal
    >
  </div>
</template>

<script>
import SeletorData from "@/components/SeletorData.vue";
import CardPalestraUsuario from "@/components/CardPalestraUsuario.vue";
import CardPalestraUsuarioMobile from "@/components/CardPalestraUsuarioMobile.vue";
//import ButtonFill from "@/components/Button-fill.vue";
import {
  gerarCertificado,
  listarPalestrasInscritasUsuario,
} from "@/services/api/usuarios";
import { baseUrl } from "@/config/constants";
import { GetCookie } from "@/utils/CookieUtil";
import { cancelarInscricaoUsuario } from "@/services/api/usuarios";

export default {
  components: {
    SeletorData,
    CardPalestraUsuario,
    //    ButtonFill,
    CardPalestraUsuarioMobile,
  },
  data() {
    return {
      showSpinner: false,
      showError: false,
      textError: "",
      inscricoes: [],
      diaSelecionado: {},
      indexAtual: null,
    };
  },
  watch: {
    diaSelecionado() {
      listarPalestrasInscritasUsuario(this.diaSelecionado).then((res) => {
        this.inscricoes = res.data;
      });
    },
  },

  methods: {
    onClickCancelarInscricao(index) {
      this.$bvModal.show("my-modal");
      this.indexAtual = index;
    },
    onCancelarInscricao() {
      let textShow;
      let titleShow;
      cancelarInscricaoUsuario(this.inscricoes[this.indexAtual]._id)
        .then(() => {
          titleShow = "";
          textShow = "Inscrição cancelada com sucesso!";
          this.toast(titleShow, "b-toaster-top-center", textShow);
          listarPalestrasInscritasUsuario(this.diaSelecionado).then((res) => {
            this.inscricoes = res.data;
          });
        })
        .catch((err) => {
          titleShow = ""; // add img exclamation
          textShow = err.response.data.error;
          this.toast(titleShow, "b-toaster-top-center", textShow);
        });
    },
    toast(titleShow, toaster, textShow, append = false) {
      this.$bvToast.toast(textShow, {
        title: titleShow,
        toaster: toaster,
        solid: true,
        appendToast: append,
      });
    },
    onClickGerarCertificado() {
      this.showSpinner = true;
      gerarCertificado()
        .then(() => {
          this.showSpinner = false;
          window.open(
            `${baseUrl}usuario/gerar-certificado?token=${GetCookie("token")}`,
            "_blank"
          );
        })
        .catch((error) => {
          this.showSpinner = false;
          this.showError = true;
          this.textError = error.response.data.error;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
html {
  background-color: #fcfcfc;
}
.btn {
  margin-bottom: 10px;
}
.background {
  font-family: Roboto;
  margin-top: 5%;
}
.cabeçalho-palestras-inscritas {
  width: 100%;
  padding: 3% 0 0 10%;
  .titulo-palestras-inscritas {
    font-size: 40px;
    font-weight: 300;
  }
}

.palestras {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.palestra {
  .btn-outline {
    width: 120px !important;
    border: 1px solid #707070 !important;
  }
}

.seletor {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

@media screen and (max-width: 991px) {
  .background {
    margin-top: 20%;
  }
  .cabeçalho-palestras-inscritas {
    width: 100%;
    padding: 0% 0 0 0%;
    text-align: center;
  }
}
</style>
